module.exports = __webpack_public_path__ + "static/media/heart24.2480323d.svg";